import React, { useEffect, useRef, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import {
  Card,
  CardContent,
  Typography,
  FormControlLabel,
  FormControl,
  Collapse,
  RadioGroup,
  Radio,
} from '@material-ui/core';
import { toast } from 'react-toastify';
import { isEmpty, get, isNil } from 'lodash';
import { CheckCircle } from '@material-ui/icons';
import moment from 'moment';
import messages from 'containers/PreOpeningPage/messages';
import { translate } from 'containers/services/translate';
import { CLAIM, CLAIM_STATUS } from 'containers/data-structure';
import { CHOICE } from 'containers/PreOpeningPage/constants';
import userPrivileges, {
  PRIVILEGES,
  userHasPrivilege,
} from 'containers/services/security/user-privileges';
import FraudeForm from 'containers/PreOpeningPage/FraudeForm';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import { Listings } from 'containers/AppContainer/typings';
import { removeDeletedItems } from 'services/utils';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { BUTTON_COLORS } from 'constants/design';
import { ContainerFraude } from 'containers/PreOpeningPage/styled-component';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import FraudeDrawer from 'containers/PreOpeningPage/FraudeDrawer';
import { formatUpdateFraudeInfo } from 'containers/PreOpeningPage/utils';
import currentUserStorage from 'containers/services/security/current-user-storage';

export interface FraudeInformationProps {
  intl: IntlShape;
  updateFilde?: Function;
  claimToPreopen: any;
  disableInput?: boolean;
  storedClaimToPreopen?: any;
  isRecapPage: boolean;
  isLawyer?: boolean;
  isRejected?: boolean;
  setDataClaimToUpdate?: Function;
  dataClaimToUpdate?: any;
  policyInfo?: any;
  listings?: Listings;
  isPreOpening?: boolean;
  setClaimRecap?: Function;
  claimRecap?: any;
  fraudInfoValidation?: any;
  requestUpdateClaim?: Function;
  claimId?: number;
  requestUpdateFraudInfo?: Function;
}

const FraudeInformation: React.FC<FraudeInformationProps> = (
  props,
): JSX.Element => {
  const claimToPreopen = !isEmpty(props.storedClaimToPreopen)
    ? { ...props.storedClaimToPreopen }
    : { ...props.claimToPreopen };
  const [disableRecapForm, setDisableRecapForm] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [updateFormFraude, setUpdateFormFraude] = useState(false);
  const [isSuspicious, setIsSuspicious] = useState(null);
  let value = !isEmpty(props.storedClaimToPreopen)
    ? { ...props.storedClaimToPreopen }
    : props.claimToPreopen;

  const { claim } = value;
  useEffect(() => {
    setIsSuspicious(
      typeof get(claim, [CLAIM.SUSPICIOUS], '') === 'string'
        ? get(claim, [CLAIM.SUSPICIOUS], '')
        : get(claim, [CLAIM.SUSPICIOUS], '')
        ? CHOICE.YES
        : CHOICE.NO,
    );
  }, [claim]);
  const handleChange = (field: string) => (
    event: React.ChangeEvent<{
      name?: string;
      value?: any;
    }>,
    valueField?: any,
  ) => {
    const { value } = event.target;

    const claimToPreopen = !isEmpty(props.storedClaimToPreopen)
      ? { ...props.storedClaimToPreopen }
      : { ...props.claimToPreopen };
    const { claim } = claimToPreopen;
    switch (field) {
      case CLAIM.SUSPICIOUS:
        claim[CLAIM.SUSPICIOUS] = String(value);
        break;
      default:
        return claimToPreopen;
    }
    setIsSuspicious(value as any);
    props.updateFilde && props.updateFilde(claimToPreopen);
  };
  const isOpeningManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISOPENINGMANAGER,
  );
  const isCourtManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISCOURTMANAGER,
  );
  const isMonitoringManager = userPrivileges.userHasPrivilege(
    PRIVILEGES.ISCOURTMONITORINGMANAGER,
  );
  const isRejected =
    get(props.storedClaimToPreopen, 'claim.status') === CLAIM_STATUS.REJECTED;

  const isValidated =
    get(props.storedClaimToPreopen, 'claim.status') === CLAIM_STATUS.VALIDATED;
  const isValidatedCorp =
    get(props.storedClaimToPreopen, 'claim.status') ===
    CLAIM_STATUS.PENDING_APPROVAL;
  const [isFormValidated, setIsFormValidated] = useState(false);

  const successCallback = () => {
    toast.success(translate(messages.validationSuccessMessage, props));
    setIsFormValidated(false);
    setUpdateFormFraude(false);
    setDisableRecapForm(false);
    setIsDrawerOpen(false);
  };

  const isClaimSuspicious = useRef(get(claim, [CLAIM.SUSPICIOUS], ''));

  useEffect(() => {
    props.setDataClaimToUpdate &&
      props.setDataClaimToUpdate({
        ...props.dataClaimToUpdate,
        claim: {
          ...get(props.dataClaimToUpdate, 'claim', {}),
          suspicious: isSuspicious === CHOICE.YES,
        },
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuspicious, !props.dataClaimToUpdate]);
  const handleUpdateFraude = (payload: any) => {
    if (isCourtManager && props.requestUpdateFraudInfo) {
      props.requestUpdateFraudInfo(
        {
          claimId: Number(props.claimId),
          suspicious: payload?.isSuspicious,
          fraudInfo: payload?.fraudInfo,
        },
        successCallback,
      );
    } else {
      const newFraudInfo =
        isSuspicious === CHOICE.YES
          ? [
              ...formatUpdateFraudeInfo(
                payload,
                get(props.claimRecap, 'victims', []),
                get(props.claimRecap, 'vehicules', []),
                !isEmpty(get(props.claimRecap, 'claim.fraudInfo[0]', {}))
                  ? {
                      ...get(props.claimRecap, 'claim.fraudInfo[0]', {}),
                      isDeleted: true,
                      updatedBy: currentUserStorage.get()?.username,
                    }
                  : {},
                isOpeningManager,
              ),
            ]
          : !isEmpty(get(props.claimRecap, 'claim.fraudInfo[0]', {}))
          ? [
              {
                ...get(props.claimRecap, 'claim.fraudInfo[0]', {}),
                isDeleted: true,
                updatedBy: currentUserStorage.get()?.username,
              },
            ]
          : [];
      props.updateFilde &&
        props.updateFilde({
          ...claimToPreopen,
          claim: {
            ...get(claimToPreopen, 'claim', {}),
            suspicious: isSuspicious === CHOICE.YES,
            fraudInfo: newFraudInfo,
          },
        });
      props.setDataClaimToUpdate &&
        props.setDataClaimToUpdate({
          ...props.dataClaimToUpdate,
          claim: {
            ...get(props.dataClaimToUpdate, 'claim', {}),
            suspicious: isSuspicious === CHOICE.YES,
            fraudInfo: newFraudInfo,
          },
        });
      setUpdateFormFraude(false);
      setDisableRecapForm(true);
      setIsDrawerOpen(false);
    }
  };
  return (
    <ContainerFraude className="container">
      <Card>
        <CardContent>
          <Typography className="title">
            {translate({ ...messages.fraudeCardTitle }, props)}
          </Typography>
          {featureService.hasFeature(FEATURES.EVOLUTION_P3) &&
            props.isRecapPage &&
            isCourtManager &&
            !isValidatedCorp && (
              <SecondaryButton
                variant="contained"
                onClick={() => {
                  if (isCourtManager) {
                    setIsDrawerOpen(true);
                  } else {
                    setDisableRecapForm(true);
                    setUpdateFormFraude(true);
                  }
                }}
                title={translate({ ...messages.updateBtnLabel }, props)}
              />
            )}
          <div className="checkdiv">
            <Typography className="text">
              {translate({ ...messages.fraudeTitle }, props)}
            </Typography>

            {!props.isRecapPage || updateFormFraude ? (
              <FormControl>
                <RadioGroup
                  row
                  onChange={handleChange(CLAIM.SUSPICIOUS)}
                  value={get(claim, [CLAIM.SUSPICIOUS], null)}
                >
                  <FormControlLabel
                    control={
                      <Radio
                        color="primary"
                        value={CHOICE.YES}
                        checkedIcon={<CheckCircle />}
                      />
                    }
                    label={translate({ ...messages.yes }, props)}
                  />
                  <FormControlLabel
                    control={
                      <Radio
                        color="primary"
                        value={CHOICE.NO}
                        checkedIcon={<CheckCircle />}
                      />
                    }
                    label={translate({ ...messages.no }, props)}
                  />
                </RadioGroup>
              </FormControl>
            ) : (
              <FormControl>
                <RadioGroup
                  row
                  onChange={handleChange(CLAIM.SUSPICIOUS)}
                  value={isSuspicious}
                >
                  <FormControlLabel
                    control={
                      <Radio
                        color="primary"
                        value={CHOICE.YES}
                        checkedIcon={<CheckCircle />}
                        disabled={
                          (isRejected && isOpeningManager) ||
                          !(isValidated
                            ? featureService.hasFeature(
                                FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
                              )
                            : true) ||
                          (isClaimSuspicious.current && props.isRecapPage) ||
                          props.disableInput ||
                          isMonitoringManager ||
                          (isCourtManager
                            ? featureService.hasFeature(
                                FEATURES.EVOLUTION_P3,
                              ) && updateFormFraude
                            : false) ||
                          !(isCourtManager
                            ? featureService.hasFeature(
                                FEATURES.UPDATE_CLAIM_COURT_MANAGER,
                              )
                            : true)
                        }
                      />
                    }
                    label={translate({ ...messages.yes }, props)}
                  />
                  <FormControlLabel
                    control={
                      <Radio
                        color="primary"
                        value={CHOICE.NO}
                        checkedIcon={<CheckCircle />}
                        disabled={
                          (isRejected && isOpeningManager) ||
                          !(isValidated
                            ? featureService.hasFeature(
                                FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
                              )
                            : true) ||
                          (isClaimSuspicious.current && props.isRecapPage) ||
                          props.disableInput ||
                          !(
                            featureService.hasFeature(FEATURES.EVOLUTION_P3) &&
                            isCourtManager &&
                            updateFormFraude
                          ) ||
                          isMonitoringManager ||
                          !(isCourtManager
                            ? featureService.hasFeature(
                                FEATURES.UPDATE_CLAIM_COURT_MANAGER,
                              )
                            : true)
                        }
                      />
                    }
                    label={translate({ ...messages.no }, props)}
                  />
                </RadioGroup>
              </FormControl>
            )}
          </div>
          {/* form for judiciary manager*/}
          {props.isRecapPage &&
            !props.isPreOpening &&
            !isOpeningManager &&
            !isEmpty(get(claimToPreopen, 'claim.fraudInfo', [])) &&
            !disableRecapForm && (
              <>
                <FraudeForm
                  victims={removeDeletedItems(
                    get(claimToPreopen, 'victims', []),
                  )}
                  vehicles={removeDeletedItems(
                    get(claimToPreopen, 'vehicules', []),
                  )}
                  lossDate={moment(
                    get(claimToPreopen, 'claim.lossDate'),
                  ).format('DD/MM/YYYY')}
                  updateFilde={props.updateFilde}
                  claimToPreopen={claimToPreopen}
                  listings={props.listings}
                  isRecapPage
                  isManager={userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER)}
                  setClaimRecap={props.setClaimRecap}
                  claimRecap={props.claimRecap}
                  isCourtManager={isCourtManager}
                />
                {!isFormValidated &&
                  isEmpty(
                    get(
                      claimToPreopen,
                      'claim.fraudInfo[0].fraudDecision[0]',
                      {},
                    ),
                  ) &&
                  isCourtManager && (
                    <div style={{ margin: '30px', paddingBottom: '30px' }}>
                      <PrimaryButton
                        background={BUTTON_COLORS.PRIMARY_BLUE}
                        border={BUTTON_COLORS.PRIMARY_BLUE}
                        titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                        title={translate(messages.validationButtonTitle, props)}
                        disabled={
                          isNil(
                            get(
                              get(claimToPreopen, 'claim.fraudInfo[0]', {}),
                              'decision.comment',
                              null,
                            ),
                          ) ||
                          isEmpty(
                            get(
                              get(claimToPreopen, 'claim.fraudInfo[0]', {}),
                              'decision.comment',
                              '',
                            ),
                          )
                        }
                        onClick={() =>
                          handleUpdateFraude({
                            fraudInfo: [
                              {
                                ...get(
                                  claimToPreopen,
                                  'claim.fraudInfo[0]',
                                  {},
                                ),
                              },
                            ],
                          })
                        }
                        className="validationButton"
                      />
                    </div>
                  )}
              </>
            )}
          {/* form for opening manager and lawyer */}

          <Collapse
            in={
              get(claim, [CLAIM.SUSPICIOUS]) === CHOICE.YES ||
              (isOpeningManager &&
                get(claim, [CLAIM.SUSPICIOUS]) &&
                !updateFormFraude)
            }
          >
            {featureService.hasFeature(FEATURES.FRAUD_INFO) && (
              <>
                <FraudeForm
                  victims={removeDeletedItems(
                    get(claimToPreopen, 'victims', []),
                  )}
                  vehicles={
                    props.isRecapPage && !props.isPreOpening
                      ? removeDeletedItems(get(claimToPreopen, 'vehicules', []))
                      : removeDeletedItems(
                          get(claimToPreopen, 'opposingParty.vehicules', []),
                        )
                  }
                  lossDate={moment(
                    get(claimToPreopen, 'claim.lossDate'),
                  ).format('DD/MM/YYYY')}
                  updateFilde={props.updateFilde}
                  claimToPreopen={claimToPreopen}
                  listings={props.listings}
                  setClaimRecap={props.setClaimRecap}
                  claimRecap={props.claimRecap}
                  isManager={userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER)}
                  fraudInfoValidation={props.fraudInfoValidation}
                  isPreOpening={props.isPreOpening}
                  isRecapPage={
                    (isOpeningManager &&
                      !updateFormFraude &&
                      !isNil(
                        get(claimToPreopen, 'claim.fraudInfo[0].id', null),
                      )) ||
                    isCourtManager
                  }
                  isCourtManager={isCourtManager}
                />
                {(isCourtManager || isOpeningManager) &&
                  !isFormValidated &&
                  isOpeningManager &&
                  !isEmpty(get(claimToPreopen, 'claim.fraudInfo[0]', {})) &&
                  disableRecapForm && (
                    <div style={{ margin: '30px', paddingBottom: '30px' }}>
                      <PrimaryButton
                        background={BUTTON_COLORS.PRIMARY_BLUE}
                        border={BUTTON_COLORS.PRIMARY_BLUE}
                        titlecolor={BUTTON_COLORS.BLUE_BUTTON_TITLE}
                        title={translate(messages.validationButtonTitle, props)}
                        onClick={() =>
                          handleUpdateFraude(
                            get(claimToPreopen, 'claim.fraudInfo[0]', {}),
                          )
                        }
                        className="validationButton"
                      />
                    </div>
                  )}
              </>
            )}
          </Collapse>
        </CardContent>
      </Card>
      <FraudeDrawer
        claimInfo={claimToPreopen}
        listings={props.listings}
        claimRecap={props.claimRecap}
        isDrawerOpen={isDrawerOpen}
        setIsDrawerOpen={setIsDrawerOpen}
        requestUpdateFraudInfo={props.requestUpdateFraudInfo}
        handleOpeningManagerUpdate={handleUpdateFraude}
      />
    </ContainerFraude>
  );
};
export default injectIntl(FraudeInformation);
